$(document).ready(function ($) {
  $(".header-menu-item").hover(
    function () {
      $(this).addClass("active");

      let _firstsubmenu = $(this).find(".submenu-item:eq(0)");
      console.log(_firstsubmenu, "_firstsubmenu");

      let _first_menu_id = _firstsubmenu.data("menu");

      _firstsubmenu.addClass("active");

      console.log(_first_menu_id, "_first_menu_id");

      let menu_products = $(
        `.header-megamenu-shop-products[data-menu="${_first_menu_id}"]`,
        this
      );
      if (menu_products.length == 1) {
        menu_products.addClass("active").siblings().removeClass("active");
      }

      $(".nav-overlay")
        .css({
          height: "100%",
          opacity: "1",
          visibility: "visible",
        })
        .fadeIn();
      $(document).on("scroll", function () {
        $(this).scrollTop(0);
      });
    },
    function () {
      $(this).removeClass("active");
      $(".submenu-item").removeClass("active");
      $(".header-megamenu-shop-products").removeClass("active");
      $(".nav-overlay")
        .css({
          height: "0px",
          opacity: "0",
          visibility: "hidden",
        })
        .fadeOut();
      $(document).off("scroll");
    }
  );

  $(".submenu-item").hover(function () {
    let _t = $(this);
    let _r = _t.parents(".header-megamenu-shop-menu");
    let menu_id = _t.data("menu");

    // set active menu
    _t.addClass("active").siblings().removeClass("active");
    let menu_products = $(
      `.header-megamenu-shop-products[data-menu="${menu_id}"]`,
      _r
    );
    if (menu_products.length == 1) {
      menu_products.addClass("active").siblings().removeClass("active");
    }
  });
});
